<template>
  <v-card
    text
    height="300"
    class="text-center"
  >
    <v-dialog v-model="dialog" persistent max-width="560">
      <v-card>
        <v-card-title
          class="headline primary white--text"
          primary-title
        >
          Get foxy with your ad creative
        </v-card-title>

        <v-card-text>
          We can connect you with vetted creative professionals to help you design captivating Facebook ads. E-mail us your project details at <a :href="`mailto:${mail}`">{{mail}}</a>, and we’ll be in touch!
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="changePage"
          >
            Thank you
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  export default {
    name: 'MessagesGetHelp',
    data () {
      return {
        dialog: true,
        mail: 'hello@outfox.ai'
      }
    },
    methods: {
      changePage () {
        this.dialog = false
        this.$emit('selectCreativePath', 'overview')
      }
    }
  }
</script>
